import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import useFamilyGroupLoader from "../hooks/useFamilyGroupLoader";
import { FamilyList } from "./FamilyList";
import { showModalFamilyGroupState } from "../atom";
import { useRecoilState } from "recoil";

export default function ModalFamilyGroup() {
  const [showModalFamilyGroup, setShowModalFamilyGroup] = useRecoilState(
    showModalFamilyGroupState
  );

  const { loading, familyGroup, payloadToken, removeFamilyMember } =
    useFamilyGroupLoader(showModalFamilyGroup);

  const handleClose = () => {
    setShowModalFamilyGroup(false);
  };

  return (
    <Dialog
      onClose={handleClose}
      open={showModalFamilyGroup}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          p: 2,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        Grupo Familiar
      </DialogTitle>
      {loading ? (
        <DialogContent sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </DialogContent>
      ) : (
        <DialogContent>
          <FamilyList
            familyGroup={familyGroup}
            payloadToken={payloadToken}
            removeFamilyMember={removeFamilyMember}
            isEditable={false}
            headerContent={
              <Stack mt={2}>
                <Typography variant="caption" color="textSecondary">
                  Aquí puedes cambiar de cuenta activa.
                </Typography>
              </Stack>
            }
          />
        </DialogContent>
      )}
      <DialogActions sx={{ p: 2, borderTop: 1, borderColor: "divider" }}>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="flex-end"
          width="100%"
        >
          <Button
            href={`${process.env.REACT_APP_ROOT_SERVER_PATH}/paciente/editar/grupo-familiar`}
            variant="contained"
            color="secondary"
            size="small"
          >
            Vincular nuevo integrante
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
